import { render, staticRenderFns } from "./ChatLive.vue?vue&type=template&id=00b98c12&scoped=true"
import script from "./ChatLive.vue?vue&type=script&lang=js"
export * from "./ChatLive.vue?vue&type=script&lang=js"
import style0 from "./ChatLive.vue?vue&type=style&index=0&id=00b98c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b98c12",
  null
  
)

export default component.exports